import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const palikaURL = `api/v1/location-app/location`;

//obtaining the paginated data
export const getPalika = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${palikaURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllPalika = () => axiosInstance.get(`${palikaURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePalika = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${palikaURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getPalikaById = (id) => axiosInstance.get(`${palikaURL}/retrieve/${id}`);

//creating function
export const createPalika = (body) => axiosInstance.post(`${palikaURL}/create`, body);
//updating function
export const updatePalika = (id, body) => axiosInstance.patch(`${palikaURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${palikaURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataPalikaName = (e, cancelToken) =>
  axiosInstance.get(`${palikaURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
